import { gql } from '@apollo/client';
import Fragments from './fragments';

export const FINANCIAL_PRODUCT_RULE_QUERY = gql`
  query financialProductRule($ruleId: Int!) {
    financialProductRule(ruleId: $ruleId) {
      ...financialProductRuleEditItem
      ruleFilters {
        ...financialProductRuleEditFilterItem
        filterValues {
          ...financialProductRuleEditFilterValueItem
        }
      }
      outputData {
        ...financialProductRuleEditOutputDataItem
      }
      outputDictionaries {
        financialProductRuleOutputDictionaryId
        financialProductRuleId
        readOnlyYN
        paramId
        paramName
        filterValue
        filterValueId
      }
      commissions {
        financialProductRuleCommissionId
        financialProductRuleId
        readOnlyYN
        commissionId
        commissionName
        commissionDefaultPercent
        commissionDefaultValue
        assignToRoleId
        assignToRoleName
        appliedToId
        appliedToName
        calculationMethodId
        calculationMethodName
        implicit
        mandatory
        calcTypeId
        calcTypeName
      }
      services {
        financialProductRuleXServiceTypeId
        financialProductRuleId
        serviceTypeId
        serviceTypeName
        calcTypeId
        calcTypeName
        percentOrValue
        implicit
        mandatory
        readOnlyYN
        financedYN
        periodicity
        supplierId
        supplierName
      }
      incomes {
        financialProductRuleIncomeId
        financialProductRuleId
        readOnlyYN
        incomeTypeId
        incomeTypeName
        value
        currencyId
        currencyCode
        implicit
        mandatory
      }
    }
  }
  ${Fragments.financialProductRuleEditItem}
  ${Fragments.financialProductRuleEditFilterItem}
  ${Fragments.financialProductRuleEditFilterValueItem}
  ${Fragments.financialProductRuleEditOutputDataItem}
`;

export const FINANCIAL_PRODUCT_RULE_GENERAL_INFO_QUERY = gql`
  query financialProductRule($ruleId: Int!) {
    financialProductRule(ruleId: $ruleId) {
      ...financialProductRuleEditItem
    }
  }
  ${Fragments.financialProductRuleEditItem}
`;

export const FINANCIAL_PRODUCT_RULE_OUTPUT_DATA_QUERY = gql`
  query financialProductRule($ruleId: Int!) {
    financialProductRule(ruleId: $ruleId) {
      outputData {
        ...financialProductRuleEditOutputDataItem
      }
    }
  }
  ${Fragments.financialProductRuleEditOutputDataItem}
`;

export const FINANCIAL_PRODUCT_RULE_OUTPUT_DATA_PARAM_LIST_QUERY = gql`
  query financialProductRuleOutputDataParamList {
    financialProductRuleOutputDataParamList {
      paramId
      paramName
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_OUTPUT_DICTIONARY_PARAM_LIST_QUERY = gql`
  query financialProductRuleOutputDictionaryParamList {
    financialProductRuleOutputDictionaryParamList {
      paramId
      paramName
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_OUTPUT_DICTIONARY_PARAM_VALUE_LIST_QUERY = gql`
  query financialProductRuleOutputDictionaryParamValueList($paramId: Int!) {
    financialProductRuleOutputDictionaryParamValueList(paramId: $paramId) {
      filterValueId
      filterValue
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_COMMISSION_LIST_QUERY = gql`
  query financialProductRuleCommissionList {
    financialProductRuleCommissionList {
      commissionId
      commissionName
      calcTypeId
      calcTypeName
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_COMMISSION_ASSIGNED_TO_LIST_QUERY = gql`
  query financialProductRuleCommissionAssignedToList {
    financialProductRuleCommissionAssignedToList {
      assignToRoleId
      assignToRoleName
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_COMMISSION_APPLIED_TO_LIST_QUERY = gql`
  query financialProductRuleCommissionAppliedToList {
    financialProductRuleCommissionAppliedToList {
      appliedToId
      appliedToName
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_COMMISSION_CALCULATION_METHOD_LIST_QUERY = gql`
  query financialProductRuleCommissionCalculationMethodList {
    financialProductRuleCommissionCalculationMethodList {
      calculationMethodId
      calculationMethodName
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_SERVICE_DETAIL_CALC_TYPE_LIST_QUERY = gql`
  query financialProductRuleServiceDetailCalcTypeList {
    financialProductRuleServiceDetailCalcTypeList {
      serviceDetailCalcTypeId
      serviceDetailCalcTypeName
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_SERVICE_SUPPLIER_LIST_QUERY = gql`
  query financialProductRuleSupplierList($filterText: String) {
    financialProductRuleSupplierList(filterText: $filterText) {
      supplierId
      supplierName
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_SERVICE_TYPE_LIST_QUERY = gql`
  query financialProductRuleServiceTypeList {
    financialProductRuleServiceTypeList {
      serviceTypeId
      serviceTypeName
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_INCOME_TYPE_LIST_QUERY = gql`
  query financialProductRuleIncomeTypeList {
    financialProductRuleIncomeTypeList {
      incomeTypeId
      incomeTypeName
    }
  }
`;
